import {
  fetchWrapper,
  handleResponse,
  hcUrl,
  buildOpts,
  formatBody,
} from 'services/RequestService/helpers';

const twoFactorOptIn = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrl('/two_factor_authentication/opt_ins'),
    buildOpts({ method: 'POST', body: formatBody(params) })
  );
  return handleResponse(response);
};

const twoFactorOptOut = async () => {
  const response = await fetchWrapper(
    hcUrl('/two_factor_authentication/opt_ins'),
    buildOpts({ method: 'DELETE' })
  );
  return handleResponse(response);
};

const getTwoFactorSettings = async () => {
  const response = await fetchWrapper(hcUrl('/two_factor_authentication/opt_ins'));
  return handleResponse(response);
};

export { twoFactorOptIn, twoFactorOptOut, getTwoFactorSettings };
